// extracted by mini-css-extract-plugin
export var emailBlockLink = "_ni-0";